import { Grid } from "@mui/material";
import { useContext } from "react";
import HeadAd from "../Components/HeadAd";
import Page from "../Components/Page";
import { AdContext } from "../context/AdContext";
import AdSection from "./AdSection";
import PostList from "./PostList";

const HomePage = () => {
  const { ads } = useContext(AdContext);
  const homeAds = ads?.filter((item) => item.ad_category.slug == "home-page");
  const banner = ads?.find(
    (item) => item.ad_category.slug == "home-page-header"
  );
  return (
    <Page>
      <Grid container className="p-2 md:p-6 lg:p-6 xl:p-6">
        <Grid item md={9} className="p-2 overflow-hidden">
          {banner && <HeadAd banner={banner} />}
          <PostList />
        </Grid>
        <Grid item md={3} className="p-2">
          <AdSection data={homeAds} />
        </Grid>
      </Grid>
    </Page>
  );
};

export default HomePage;
